<!-- 训练模型流程 -->
<template>
  <div class="training-model-process">
    <div class="training-model-process-header">
      <i class="line"></i>
      <h4 class="title">训练模型主要流程</h4>
    </div>
    <div class="training-model-process-content">
      <ul>
        <li :class="[currentProcess === '数据归一化'?'current-process':'']" @click="onSelectProcess('数据归一化')" v-if="modelType == 1 || modelType == 2">数据归一化</li>
        <li :class="[currentProcess === '数据归一化'?'current-process':'']" @click="onSelectProcess('数据归一化')" v-if="modelType == 5 || modelType == 6">特征提取</li>
        <i class="icon-right-arrow" v-if="modelType == 1 || modelType == 2 || modelType == 5 || modelType == 6"></i>
        <li :class="[currentProcess === '定义网络层'?'current-process':'']" @click="onSelectProcess('定义网络层')">定义网络层</li>
        <i class="icon-right-arrow"></i>
        <li :class="[currentProcess === '定义优化器和代价函数'?'current-process':'']" @click="onSelectProcess('定义优化器和代价函数')">定义优化器和代价函数</li>
        <i class="icon-right-arrow"></i>
        <li :class="[currentProcess === '训练'?'current-process':'']" @click="onSelectProcess('训练')">训练</li>
        <i class="icon-right-arrow"></i>
        <li :class="[currentProcess === '校验'?'current-process':'']" @click="onSelectProcess('校验')">校验</li>
        <i class="icon-right-arrow"></i>
        <li :class="[currentProcess === '训练模型输出结果'?'current-process':'']" @click="onSelectProcess('训练模型输出结果')">输出结果</li>
      </ul>

      <!-- 代码编写区 -->
      <div class="content-text">
        <div class="content-text-one" v-if="currentProcess === '数据归一化' && (modelType == 1 || modelType == 2)">
          <p>train_images <i class="text-navy-blue">=</i> <i class="text-blue">train_images / 255.0</i></p>
        </div>

        <div class="content-text-one" v-if="currentProcess === '数据归一化' && (modelType == 5 || modelType == 6)">
          <p><i class="text-blue">def</i> <i class="text-pink">get_melspectrogram_layer</i> <i class="text-navy-blue">(</i></p>
          <p>input_shape <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 模型输入形状</i></p>
          <p>n_fft <i class="text-navy-blue">=</i> <i class="text-red">2048</i>, <i class="text-green"># 快速傅里叶变化点数</i></p>
          <p>win_length <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 短时傅里叶变换时窗长度</i></p>
          <p>hop_length <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 短时傅里叶变换跳长</i></p>
          <p>window_name <i class="text-navy-blue">=</i> <i class="text-blue">None</i>,</p>
          <p>pad_begin <i class="text-navy-blue">=</i> <i class="text-blue">False</i>,</p>
          <p>pad_end <i class="text-navy-blue">=</i> <i class="text-blue">False</i>,</p>
          <p>sample_rate <i class="text-navy-blue">=</i> <i class="text-red">22050</i>, <i class="text-green"># 采样率</i></p>
          <p>n_mels <i class="text-navy-blue">=</i> <i class="text-red">128</i>, <i class="text-green"># 梅尔容器所在梅尔过滤器组的数目</i></p>
          <p>mel_f_min <i class="text-navy-blue">=</i> <i class="text-red">0.0</i>, <i class="text-green"># 梅尔过滤器组的最低频</i></p>
          <p>mel_f_max <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 梅尔过滤器组的最高频</i></p>
          <p>mel_htk <i class="text-navy-blue">=</i> <i class="text-blue">False</i>,</p>
          <p>mel_norm <i class="text-navy-blue">=</i> <i class="text-blue">'slaney'</i>, <i class="text-green"># 梅尔滤波器组三角归一化策略</i></p>
          <p>return_decibel <i class="text-navy-blue">=</i> <i class="text-blue">False</i>,</p>
          <p>db_amin <i class="text-navy-blue">=</i> <i class="text-red">1e-5</i>, <i class="text-green"># 分贝缩放输入的噪声下限</i></p>
          <p>db_ref_value <i class="text-navy-blue">=</i> <i class="text-red">1.0</i>, <i class="text-green"># 分贝标度的参考值</i></p>
          <p>db_dynamic_range <i class="text-navy-blue">=</i> <i class="text-red">80.0</i>, <i class="text-green"># 分贝缩放结果的动态范围值</i></p>
          <p>input_data_format <i class="text-navy-blue">=</i> <i class="text-blue">'default'</i>,</p>
          <p>output_data_format <i class="text-navy-blue">=</i> <i class="text-blue">'default'</i>,</p>
          <p>name <i class="text-navy-blue">=</i> <i class="text-blue">'melspectrogram'</i>,</p>
          <p class="text-navy-blue">) : </p>
        </div>

        <div class="content-text-two" v-if="currentProcess === '定义网络层' && modelType == 1">
          <p><i class="text-blue">def</i> <i class="text-pink">InceptionV</i> <i class="text-navy-blue">(</i></p>
          <p>input_shape <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 输入数据的形状</i></p>
          <p>include_top <i class="text-navy-blue">=</i> <i class="text-blue">True</i>, <i class="text-green"># 是否包含顶层网络中的全连接层</i></p>
          <p>weights <i class="text-navy-blue">=</i> <i class="text-blue">'imagenet'</i>, <i class="text-green"># 权重-imagenet预训练模型的权重文件</i></p>
          <p>input_tensor <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 输入张量-默认None</i></p>
          <p>pooling <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 默认None-4D张量输出</i></p>
          <p>classes <i class="text-navy-blue">=</i> <i class="text-blue">classes</i>, <i class="text-green"># 数据总类别数</i></p>
          <p>classifier_activation <i class="text-navy-blue">=</i> <i class="text-blue">'softmax'</i>, <i class="text-green"># 激活函数-逻辑回归函数</i></p>
          <p class="text-navy-blue">) : </p>
          <p>......</p>
          <p>......</p>
        </div>

        <div class="content-text-two" v-if="currentProcess === '定义网络层' && modelType == 2">
          <p><i class="text-blue">def</i> <i class="text-pink">build_network</i> <i class="text-navy-blue">(</i> self, sess, is_training<span class="text-navy-blue"> = <i class="text-blue">True</i> ) :</span></p>
          <p>......</p>
          <p>rpn_cls_prob, rpn_bbox_pred, rpn_cls_score, rpn_cls_score_reshape <i class="text-navy-blue">=</i> self.build_rpn <i class="text-navy-blue">(</i> net, is_training, initializer <i class="text-navy-blue">)</i>
            <i class="text-green"> # 建立目标 rpn_bbox_pred为坐标值</i>
          </p>
          <p>rois <i class="text-navy-blue">=</i> self.build_proposals <i class="text-navy-blue">(</i> is_training, rpn_cls_prob, rpn_bbox_pred, rpn_cls_score <i class="text-navy-blue">)</i></p>
          <p>cls_score, cls_prob, bbox_pred <i class="text-navy-blue">=</i> self.build_predictions <i class="text-navy-blue">(</i> net, rois, is_training, initializer, initializer_bbox <i class="text-navy-blue">)</i></p>
          <p>self._predictions<span class="text-navy-blue">[<i class="text-greyish-white">"rpn_cls_score"</i>] =</span> rpn_cls_score</p>
          <p>self._predictions<span class="text-navy-blue">[<i class="text-greyish-white">"rpn_cls_score_reshape"</i>] =</span> rpn_cls_score_reshape</p>
          <p>self._predictions<span class="text-navy-blue">[<i class="text-greyish-white">"rpn_cls_prob"</i>] =</span> rpn_cls_prob</p>
          <p>self._predictions<span class="text-navy-blue">[<i class="text-greyish-white">"rpn_bbox_pred"</i>] =</span> rpn_bbox_pred</p>
          <p>self._predictions<span class="text-navy-blue">[<i class="text-greyish-white">"cls_score"</i>] =</span> cls_score</p>
          <p>self._predictions<span class="text-navy-blue">[<i class="text-greyish-white">"cls_prob"</i>] =</span> cls_prob</p>
          <p>self._predictions<span class="text-navy-blue">[<i class="text-greyish-white">"bbox_pred"</i>] =</span> bbox_pred</p>
          <p>self._predictions<span class="text-navy-blue">[<i class="text-greyish-white">"rois"</i>] =</span> rois</p>
          <p>self._score_summaries.update <i class="text-red">(</i> self._predictions <i class="text-red">)</i></p>
        </div>

        <div class="content-text-two" v-if="currentProcess === '定义网络层' && (modelType == 3 || modelType == 4)">
          <p><i class="text-blue">class</i> Net:</p>
          <p>......</p>
          <p class="p-no-text-indent"><i class="text-blue">def</i> <i class="text-pink">net</i> <i class="text-navy-blue">(</i></p>
          <p>self,</p>
          <p>word_size, <i class="text-green">#文本词汇大小</i></p>
          <p>out_size, <i class="text-green">#　输出数目</i></p>
          <p>core, <i class="text-green">#  核信息的大小</i></p>
          <p>drop, <i class="text-green">#　防止过拟合所丢弃的信息量</i></p>
          <p><span class="text-navy-blue"> ) :</span></p>
          <p>self.model.add<span class="text-red">(<i class="text-white">keras.layers.Embedding<i class="text-red">(<i class="text-white">word_size, core</i>)</i></i>) </span> <i class="text-green">#　嵌入层</i></p>
          <p>self.model.add<span class="text-red">(<i class="text-white">keras.layers.Dropout<i class="text-red">(<i class="text-white">drop</i>)</i></i>) </span></p>
          <p>self.model.add<span class="text-red">(<i class="text-white">keras.layers.GlobalAveragePooling1D<i class="text-red">()</i></i>) </span> <i class="text-green">#　池化</i></p>
          <p>self.model.add<span class="text-red">(<i class="text-white">keras.layers.Dropout<i class="text-red">(<i class="text-white">drop</i>)</i></i>) </span></p>
          <p>self.model.add<span class="text-red">(<i class="text-white">keras.layers.Dense<i class="text-red">(<i class="text-white">out_size, activation <i class="text-navy-blue">=</i> '<i class="text-blue">softmax</i>'</i>)</i></i>) </span> <i class="text-green">#　输出层</i></p>
        </div>

        <div class="content-text-two" v-if="currentProcess === '定义网络层' && (modelType == 5 || modelType == 6)">
          <p><i class="text-blue">def</i> <i class="text-pink">DefLSTMNet</i> <i class="text-navy-blue">(</i></p>
          <p>units, <i class="text-green"># 维度</i></p>
          <p>activation <i class="text-navy-blue">=</i> <i class="text-blue">'tanh'</i>, <i class="text-green"># 激活函数</i></p>
          <p>recurrent_activation <i class="text-navy-blue">=</i> <i class="text-blue">'hard_sigmoid'</i>, <i class="text-green"># 重复步骤的激活函数</i></p>
          <p>use_bias <i class="text-navy-blue">=</i> <i class="text-blue">True</i>, <i class="text-green"># 是否使用层偏移向量</i></p>
          <p>......</p>
          <p class="text-navy-blue">) : </p>
        </div>

        <div class="content-text-three" v-if="currentProcess === '定义优化器和代价函数'">
          <p><i class="text-blue">def</i> <i class="text-pink">compile</i> <i class="text-navy-blue">(</i></p>
          <p>optimizer <i class="text-navy-blue">=</i> <i class="text-blue">optimizer</i>, <i class="text-green"># 优化器</i></p>
          <p>loss <i class="text-navy-blue">=</i> <i class="text-blue">loss_fun</i>, <i class="text-green"># 代价函数</i></p>
          <p>metrics <span class="text-navy-blue">= [<i class="text-greyish-white">"accuracy"</i>]</span> <i class="text-green"># 精度指标</i></p>
          <p class="text-navy-blue">)</p>
          <p>......</p>
        </div>

        <div class="content-text-four" v-if="currentProcess === '训练'">
          <p><i class="text-blue">def</i> <i class="text-pink">fit</i> <i class="text-navy-blue">(</i></p>
          <p>self,</p>
          <p>x <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 训练数据</i></p>
          <p>y <i class="text-navy-blue">=</i> <i class="text-blue">None</i>,</p>
          <p>batch_size <i class="text-navy-blue">=</i> <i class="text-blue">None</i>,</p>
          <p>epochs <i class="text-navy-blue">=</i> <i class="text-red">1</i>, <i class="text-green"># 轮次</i></p>
          <p>verbose <i class="text-navy-blue">=</i> <i class="text-red">1</i>,</p>
          <p>callbacks <i class="text-navy-blue">=</i> <i class="text-blue">None</i>,</p>
          <p>validation_split <i class="text-navy-blue">=</i> <i class="text-red">0</i>,</p>
        </div>

        <div class="content-text-five" v-if="currentProcess === '校验'">
          <p><i class="text-blue">def</i> <i class="text-pink">evaluation</i> <i class="text-navy-blue">(</i> </p>
          <p>validation_data <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 校验数据</i></p>
          <p>shuffle <i class="text-navy-blue">=</i> <i class="text-blue">True</i>,</p>
          <p>class_weight <i class="text-navy-blue">=</i> <i class="text-blue">None</i>,</p>
          <p>sample_weight <i class="text-navy-blue">=</i> <i class="text-blue">None</i>,</p>
          <p>initial_epoch <i class="text-navy-blue">=</i> <i class="text-red">0</i>,</p>
          <p>steps_per_epoch <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 每轮步数</i></p>
          <p>validation_steps <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 校验的步数</i></p>
          <p>validation_batch_size <i class="text-navy-blue">=</i> <i class="text-blue">None</i>,</p>
          <p>validation_freq <i class="text-navy-blue">=</i> <i class="text-red">1</i>,</p>
          <p>max_queue_size <i class="text-navy-blue">=</i> <i class="text-red">10</i>,</p>
          <p>workers <i class="text-navy-blue">=</i> <i class="text-red">1</i>,</p>
          <p>use_multiprocessing <i class="text-navy-blue">=</i> <i class="text-blue">False</i> <i class="text-navy-blue">) :</i></p>
        </div>

        <div class="content-text-six" v-if="currentProcess === '训练模型输出结果'">
          <img v-if="modelType == 1 || modelType == 3 || modelType == 4 || modelType == 5 || modelType == 6" src="../../assets/images/output-of-training-model-01.png" />
          <img v-if="modelType == 2" src="../../assets/images/output-of-training-model-02.png" />
        </div>
      </div>
      <div class="upper-lower-button">
        <el-button type="primary" @click="onLastStep">上一步</el-button>
        <el-button type="primary" @click="onNextStep">{{currentProcess==='训练模型输出结果'?'我知道了':'下一步'}}</el-button>
      </div>
      <!-- <el-checkbox
        class="check-box"
        v-model="trainingNoTips"
        @change="trainingNoTipsChange"
        >下次不再提示</el-checkbox
      > -->
    </div>
  </div>
</template>

<script>
// import PROJECTS from '@/axios/trainingCenter/projects/projects.js'
// import GatPopup from '@/components/common/GatPopup'

export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'TrainingModelProcess',
  components: { },
  props: {
    modelType: {
      type: String,
      default: '1' // 1图像分类，2图像检测，3文本分类，4文本标注
    }
  },
  data() {
    return {
      currentProcess: '数据归一化',
      trainingNoTips: false,
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.modelType == 1 || this.modelType == 2 || this.modelType == 5 || this.modelType == 6) {
      this.currentProcess = '数据归一化'
    } else {
      this.currentProcess = '定义网络层'
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.localStorageTrainingNoTips()
  },
  methods: {
    onSelectProcess(val) {
      this.currentProcess = val
    },
    // 上一步
    onLastStep() {
      if (this.currentProcess === '训练模型输出结果') {
        this.currentProcess = '校验'
      } else if (this.currentProcess === '校验') {
        this.currentProcess = '训练'
      } else if (this.currentProcess === '训练') {
        this.currentProcess = '定义优化器和代价函数'
      } else if (this.currentProcess === '定义优化器和代价函数') {
        this.currentProcess = '定义网络层'
      } else if (this.currentProcess === '定义网络层') {
          if (this.modelType == 1 || this.modelType == 2 || this.modelType == 5 || this.modelType == 6) {
            this.currentProcess = '数据归一化'
          } else {
            this.$emit('toTrainingModelPage')
          }
      } else if (this.currentProcess === '数据归一化') {
        this.$emit('toTrainingModelPage')
      }
    },
    // 下一步
    onNextStep() {
      if (this.currentProcess === '数据归一化') {
        this.currentProcess = '定义网络层'
      } else if (this.currentProcess === '定义网络层') {
        this.currentProcess = '定义优化器和代价函数'
      } else if (this.currentProcess === '定义优化器和代价函数') {
        this.currentProcess = '训练'
      } else if (this.currentProcess === '训练') {
        this.currentProcess = '校验'
      } else if (this.currentProcess === '校验') {
        this.currentProcess = '训练模型输出结果'
      } else if (this.currentProcess === '训练模型输出结果') {
        // this.currentProcess = '数据归一化'
        this.$emit('toTrainingModelPage')
        // this.$emit('startTraining')
      }
    },
    trainingNoTipsChange(val) {
      this.trainingNoTips = val
      if (this.modelType == 1) {
        window.localStorage.setItem('__training_noTips_one__', val)
      } else if (this.modelType == 2) {
        window.localStorage.setItem('__training_noTips_two__', val)
      } else if (this.modelType == 3) {
        window.localStorage.setItem('__training_noTips_three__', val)
      } else if (this.modelType == 4) {
        window.localStorage.setItem('__training_noTips_four__', val)
      } else if (this.modelType == 5) {
        window.localStorage.setItem('__training_noTips_five__', val)
      } else if (this.modelType == 6) {
        window.localStorage.setItem('__training_noTips_six__', val)
      }
      // this.localStorageTrainingNoTips('save', val)
    },
    localStorageTrainingNoTips(type, val) {
      if (type === 'save') {
        this.trainingNoTips = value
        window.localStorage.setItem('__training_noTips__', value)
      } else {
        let trainingNoTips = window.localStorage.getItem('__training_noTips__')
        this.trainingNoTips = trainingNoTips ? trainingNoTips : false
      }
    }
  },
  updated() {}, //生命周期 - 更新之后
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.training-model-process {
  width: 1020px;
  height: 480px;
  background: #fff;
  position: absolute;
  top: -70px;
  left: -20px;
  z-index: 1;
  .training-model-process-header {
    width: 100%;
    height: 50px;
    border-bottom: 1px solid #E6E9F2;
    padding: 0 20px;
    display: flex;
    align-items: center;
    .line {
      width: 4px;
      height: 17px;
      background: #4C88FF;
      margin-right: 10px;
    }
    .title {
      color: #333333;
      font-size: 18px;
      font-weight: 400;
    }
  }
  .training-model-process-content {
    padding: 25px 70px 0;
    ul {
      height: 40px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      li {
        height: 40px;
        box-sizing: border-box;
        min-width: 110px;
        font-size: 15px;
        color: #000000;
        border-top: 1px solid #D9DEEA;
        border-left: 1px solid #D9DEEA;
        border-right: 1px solid #D9DEEA;
        border-radius: 5px 5px 0 0;
        // float: left;
        padding: 0px 20px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
      }
      .icon-right-arrow {
        width: 13px;
        height: 9px;
        background: url("../../assets/images/icon-right-arrow.png") no-repeat;
        margin: 0 2px;
      }
      .current-process {       
        color: #FFFFFF;
        background: #4C88FF;
      }
    }

    .content-text {
      width: 871px;
      height: 280px;
      // background: #FFFFFF;
      background: rgba(0, 0, 0, 0.9);
      border: 1px solid #D9DEEA;
      padding: 15px 30px;
      overflow: auto;

      // &::-webkit-scrollbar {
      //   width: 10px; /*滚动条宽度*/
      //   height: 10px; /*滚动条高度*/
      // }

      // /*定义滚动条轨道 内阴影+圆角*/
      // &::-webkit-scrollbar-track {
      //   // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
      //   // border-radius: 10px; /*滚动条的背景区域的圆角*/
      //   // background: rgba(0, 96, 255, 0.1); /*滚动条的背景颜色*/
      // }

      // /*定义滑块 内阴影+圆角*/
      // &::-webkit-scrollbar-thumb {
      //   border-radius: 3px; /*滚动条的圆角*/
      //   // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
      //   // background: rgba(0, 96, 255, 0.1); /*滚动条的背景颜色*/
      //   background: #4C88FF; /*滚动条的背景颜色*/
      // }

      p {
        color: #fff;
        // color: #333333;
        font-size: 15px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 26px;
      }

      .content-text-one,
      .content-text-two,
      .content-text-three,
      .content-text-four,
      .content-text-five {
        p:nth-child(n+2) {
          text-indent: 2em;
        }
      }

      i {
        color: #fff;
        font-style: normal;
      }

      .text-blue {
        color: #3A90FF;
      }
      .text-pink {
        // color: #FFB6FF;
        color: #FF66FF;
      }
      .text-green {
        color: #3AAD66;
      }
      .text-red {
        color: #FF3A3A;
      }
      .text-navy-blue {
        color: #0066B6;
      }
      .text-greyish-white {
        color: #696969;
      }

      .p-no-text-indent {
        text-indent: 0em !important;
      }
    }

    .upper-lower-button {
      text-align: center;
      margin: 10px 0;
      .el-button {
        width: 70px;
        height: 30px;
        background: #4C88FF;
        border-radius: 3px;
        padding: 0;
      }
    }

    .el-checkbox{
      margin-left: -22px;
    } 
    ::v-deep.el-checkbox__inner {
      border: 1px solid #606266;
      border-radius: 50%;
    }
    .is-checked {
      ::v-deep.el-checkbox__inner {
        border: 1px solid #4c88ff;
      }
    }
  }
}
</style>
